/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionRemotePatientSearchFieldMap } from './PalAuthSubmissionRemotePatientSearchFieldMap';
import {
    PalAuthSubmissionRemotePatientSearchFieldMapFromJSON,
    PalAuthSubmissionRemotePatientSearchFieldMapFromJSONTyped,
    PalAuthSubmissionRemotePatientSearchFieldMapToJSON,
} from './PalAuthSubmissionRemotePatientSearchFieldMap';

/**
 * 
 * @export
 * @interface PalAuthSubmissionRemotePatientSearchConfig
 */
export interface PalAuthSubmissionRemotePatientSearchConfig {
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmissionRemotePatientSearchConfig
     */
    can_search_remote_patient?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionRemotePatientSearchConfig
     */
    category_label?: string;
    /**
     * 
     * @type {PalAuthSubmissionRemotePatientSearchFieldMap}
     * @memberof PalAuthSubmissionRemotePatientSearchConfig
     */
    field_map?: PalAuthSubmissionRemotePatientSearchFieldMap;
}

/**
 * Check if a given object implements the PalAuthSubmissionRemotePatientSearchConfig interface.
 */
export function instanceOfPalAuthSubmissionRemotePatientSearchConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionRemotePatientSearchConfigFromJSON(json: any): PalAuthSubmissionRemotePatientSearchConfig {
    return PalAuthSubmissionRemotePatientSearchConfigFromJSONTyped(json, false);
}

export function PalAuthSubmissionRemotePatientSearchConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionRemotePatientSearchConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'can_search_remote_patient': !exists(json, 'can_search_remote_patient') ? undefined : json['can_search_remote_patient'],
        'category_label': !exists(json, 'category_label') ? undefined : json['category_label'],
        'field_map': !exists(json, 'field_map') ? undefined : PalAuthSubmissionRemotePatientSearchFieldMapFromJSON(json['field_map']),
    };
}

export function PalAuthSubmissionRemotePatientSearchConfigToJSON(value?: PalAuthSubmissionRemotePatientSearchConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'can_search_remote_patient': value.can_search_remote_patient,
        'category_label': value.category_label,
        'field_map': PalAuthSubmissionRemotePatientSearchFieldMapToJSON(value.field_map),
    };
}

